import React from 'react'
import { css } from '@emotion/css'
import { LoadingMaskRectangle } from './loading-mask-rectangle'

export function LoadingMaskThermometer() {
  return (
    <LoadingMaskRectangle
      width={250}
      height={8}
      borderRadius={5}
      className={css`
        width: 100%;
      `}
      colorValue="lighter"
    />
  )
}
